export const consoleLog = (...message: any) => {
    process.env.NEXT_PUBLIC_ENVIROMENT !== "PRODUCTION" && console.log(message);
}
export const errorLog = (...message: any) => {
    process.env.NEXT_PUBLIC_ENVIROMENT !== "PRODUCTION" && console.error(message);
}
export const warningLog = (...message: any) => {
    process.env.NEXT_PUBLIC_ENVIROMENT !== "PRODUCTION" && console.warn(message);
}
